import {
  loadFixture, paginate, findById, parseBody, parseQuery, nextId, urlParam,
  CURRENT_USER_PROFILE_REF, groupIdentifierFromUrl, groupFixtureName,
} from '../mockDataStore';

const MESSAGE_LIST = /^\/?api\/v1\/groups\/[\w-]+\/messages\/?(\?.*)?$/;
const MESSAGE_DETAIL = /^\/?api\/v1\/groups\/[\w-]+\/messages\/(\d+)\/?$/;
const MESSAGE_RESEND = /^\/?api\/v1\/groups\/[\w-]+\/messages\/(\d+)\/resend\/?$/;
const SEND_MESSAGE = /^\/?api\/v1\/groups\/[\w-]+\/send_message\/?$/;

const SENDER = {
  id: CURRENT_USER_PROFILE_REF.id,
  slug: CURRENT_USER_PROFILE_REF.slug,
  name: `${CURRENT_USER_PROFILE_REF.first_name} ${CURRENT_USER_PROFILE_REF.last_name}`,
  profile_picture: CURRENT_USER_PROFILE_REF.profile_picture,
};

function loadMessages(url) {
  return loadFixture(groupFixtureName('groups/messages', groupIdentifierFromUrl(url)));
}

/** Members who would receive the message: the group's current (cached) profiles. */
async function countRecipients(url) {
  const profiles = await loadFixture(groupFixtureName('groups/profiles', groupIdentifierFromUrl(url)));
  return profiles.results.length;
}

/** Records a send the same way the API does: a new row, newest first, optionally linked to an earlier one. */
function recordMessage(messages, {
  subject, message, recipientCount, resentFrom = null,
}) {
  const created = {
    id: nextId(messages.results),
    subject,
    message,
    sender: SENDER,
    sender_name: SENDER.name,
    recipient_count: recipientCount,
    status: 'sent',
    error: '',
    resent_from: resentFrom,
    resend_count: 0,
    sent_at: new Date().toISOString().replace(/\.\d{3}Z$/, 'Z'),
  };
  messages.results.unshift(created);
  const original = findById(messages.results, resentFrom);
  if (original) original.resend_count += 1;
  return created;
}

export default function registerGroupMessageMocks(mock) {
  mock.onGet(MESSAGE_LIST).reply(async (config) => {
    const messages = await loadMessages(config.url);
    return [200, paginate(messages.results, { ...parseQuery(config.url), ...config.params })];
  });

  mock.onGet(MESSAGE_DETAIL).reply(async (config) => {
    const messages = await loadMessages(config.url);
    const found = findById(messages.results, Number(urlParam(config, MESSAGE_DETAIL)));
    return found ? [200, found] : [404, { detail: 'Not found.' }];
  });

  mock.onPost(MESSAGE_RESEND).reply(async (config) => {
    const messages = await loadMessages(config.url);
    const original = findById(messages.results, Number(urlParam(config, MESSAGE_RESEND)));
    if (!original) return [404, { detail: 'Not found.' }];
    return [201, recordMessage(messages, {
      subject: original.subject,
      message: original.message,
      recipientCount: await countRecipients(config.url),
      resentFrom: original.id,
    })];
  });

  mock.onPost(SEND_MESSAGE).reply(async (config) => {
    const messages = await loadMessages(config.url);
    const body = parseBody(config);
    return [201, recordMessage(messages, {
      subject: body.subject || 'Message to group members!',
      message: body.message,
      recipientCount: await countRecipients(config.url),
      resentFrom: body.resent_from || null,
    })];
  });
}
